import * as yup from 'yup';
import { withdrawRequestRejectFormFields } from '../../fields/formFields';

export const withdrawRequestRejectionFormSchema = yup.object({
  [withdrawRequestRejectFormFields.reviewComment]: yup.string().required(),
});
